import { Checkbox } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Confirmation from '../../../../assets/Confirmation/Confirmation';
import remove from '../../../images/trash.png';
import { useContext } from 'react';
import { IndividualWorkPlanContext } from '../../../../utils/context';
import styles from '../../individualWorkPlan.module.css';
import Modal from 'react-modal';
import { useFormik } from 'formik';



const AcademicWorkRow = ({ item, academicWorkGroup }) => {

    const { id, addIndividualPlanI, editIndividualPlanI, deleteIndividualPlanI, editIndividualPlanIII, mid, xp_key } = useContext(IndividualWorkPlanContext)

    const [formData, setFormData] = useState(item)
    const [confirmation, setConfirmation] = useState(null)

    const [selectedGroup, setSelectedGroup] = useState('');
    const [planDone, setPlanDone] = useState(''); /// остальные значения...
    const [openModalGroup, setOpenModalGroup] = useState('');

    useEffect(() => {
        !!item && setFormData(item)
    }, [item])
    useEffect(() => {
        selectedGroup && openModalGroup && setFormData(() => ({ [openModalGroup]: selectedGroup }))
    }, [selectedGroup])

    const {
        values,
        handleChange,
        setFieldValue,
        handleSubmit
    } = useFormik({
        initialValues: item || {},
        enableReinitialize: true,
        onSubmit: submitForm
    })
    const selectGroup = (group) => {
        setSelectedGroup((prev) => [...prev, group.gid])
    }

    const closeModalGroup = () => {
        editIndividualPlanIII({ data: formData, kid: item.id, ip_id: id, mid, xp_key })
        setOpenModalGroup(null)
    }

    const submitForm = () => {
        // Функция для удаления ключей со значением null
        const removeNullKeys = obj => Object.fromEntries(
            Object.entries(obj).filter(([_, v]) => v != null)
        );

        const notNull = removeNullKeys(values)
        editIndividualPlanIII({ data: notNull, kid: item.id, ip_id: id, mid, xp_key })
    }

    const { kind_name, groupnames1, plan_1, fact_1, groupnames2, plan_2, fact_2, s_plan, s_fact, id: plan } = values
    return (
        <tr className={styles.academicRow} onBlur={() => submitForm()}>
            <Modal
                isOpen={!!openModalGroup}
                // className={"StudentProjectSmallModal"}
                className={styles.modalGroup}
                onRequestClose={() => closeModalGroup(null)}
                contentLabel="Modal"
            >
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>№ п/п</th>
                        </tr>
                    </thead>
                    <tbody>
                        {academicWorkGroup && academicWorkGroup.map(el =>

                            <tr
                                style={{ backgroundColor: academicWorkGroup?.find(el => (el.id == plan)) ? '#3689FF' : '' }}
                                onClick={() => selectGroup(el)} >
                                <td>{el.groupname}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </Modal>
            <td >
                {kind_name}
            </td>
            <td style={{ position: 'relative' }}>{groupnames1}
                {/* <button className={styles.plusGroup} onClick={() => setOpenModalGroup('gids1')}><p>+</p></button> */}
            </td>
            <td>
                <input
                    name='plan_1'
                    value={plan_1}
                    disabled
                    onChange={handleChange}
                    style={{
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        border: 'none',
                        resize: 'none',

                    }}
                    className={styles.textArea}
                />
            </td>
            <td>
                <input
                    name='fact_1'
                    value={fact_1}
                    disabled
                    onChange={handleChange}
                    style={{
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        border: 'none',
                        resize: 'none',

                    }}
                    className={styles.textArea}
                />
            </td>
            <td style={{ position: 'relative' }}>{groupnames2}
                {/* <button className={styles.plusGroup} onClick={() => setOpenModalGroup('gids2')}><p>+</p></button> */}
            </td>
            <td>{plan_2}</td>
            <td>{fact_2}</td>
            <td>{s_fact}</td>
            <td>{s_plan}</td>
        </tr>
    )
}


export default AcademicWorkRow